export const getFileType = (fileName: string) => fileName.split('.').pop()?.toUpperCase() || 'FILE'

export const imageExtensions = new Set([
  'apng',
  'avif',
  'bmp',
  'gif',
  'heic',
  'heif',
  'ico',
  'jpeg',
  'jpg',
  'png',
  'svg',
  'tif',
  'tiff',
  'webp',
])

export const isImageFile = (fileName: string, file?: File) =>
  Boolean(file?.type.startsWith('image/')) || imageExtensions.has(fileName.split('.').pop()?.toLowerCase() ?? '')
